module.exports = __webpack_public_path__ + "static/img/icon-step4-on.dda1378a.png";